import Model from './model'

export default class CustomerEnquiry extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/customer-enquiry'
    }
}
